import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=7d4e59f8&"
import script from "./CategoryFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/joelstorm/Sites/hanken-sse-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7d4e59f8', component.options)
    } else {
      api.reload('7d4e59f8', component.options)
    }
    module.hot.accept("./CategoryFilter.vue?vue&type=template&id=7d4e59f8&", function () {
      api.rerender('7d4e59f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/CategoryFilter.vue"
export default component.exports